export const REGISTRATION_FEE_DOLLARS = 300;

export const DONATION_PRESET_OPTIONS = [50, 100, 250];

export const ROLE_OPTIONS = [
  { key: "vineyardOwner", label: "Vineyard owner or operator" },
  { key: "producer", label: "Wine producer" },
  { key: "brandOwner", label: "Wine brand owner" },
  { key: "importer", label: "Importer" },
  { key: "retailer", label: "Retailer" },
] as const;

export const INTENDED_USE_OPTIONS = [
  { key: "packaging", label: "Wine bottles, labels, or other packaging" },
  { key: "website", label: "Website or e-commerce listings" },
  { key: "marketing", label: "Printed marketing or sales materials" },
  { key: "shelfTalkers", label: "Shelf talkers or retail displays" },
  { key: "wineLists", label: "Wine lists" },
  { key: "signage", label: "Vineyard or winery signage" },
  { key: "otherPromo", label: "Other approved promotional materials" },
] as const;

export const ATTESTATION_TEXTS = [
  "I am authorized to register and accept the OVR Seal terms on behalf of the legal organization and the brand or business named above.",
  "I have verified with any applicable regulatory bodies in my region that my intended use of the OVR Seal complies with legal and other regulatory guidelines in my area.",
  "I understand that this registration applies only to the wine brand, vineyard business, importing business, or retail business named in this application.",
  "I understand that this registration does not authorize use by another wine brand or organization, including one under common ownership, production, management, or control.",
  "We will use an OVR age seal only when at least 85% of the wine's grapes come from vineyards registered in the Old Vine Registry that meet or exceed the age shown on the seal.",
  "The OVR vineyard links provided in this registration accurately identify vineyards associated with our intended use of the seal.",
  "We will select the appropriate age seal based on the planting dates displayed in the OVR and follow the current OVR Seal Usage Guidelines.",
  "We will use only official OVR Seal artwork supplied by the Old Vine Registry and will not alter, redraw, or modify it.",
  "We will not give, sell, sublicense, or otherwise provide the seal artwork to another wine brand or organization for its independent use.",
  "We will use the seal only in contexts permitted for our registered role and will not use it in a way that implies every wine we make, import, distribute, or sell qualifies.",
  "We will reassess a wine's eligibility whenever its vineyard sources, percentages, or relevant OVR records change.",
  "We understand that OVR may review our use of the seal and may withdraw recognition if use is materially inaccurate, misleading, unauthorized, or inconsistent with the Usage Guidelines.",
];

export const COUNTRY_OPTIONS = [
  "Afghanistan",
"Albania",
"Algeria",
"Andorra",
"Angola",
"Antigua and Barbuda",
"Argentina",
"Armenia",
"Australia",
"Austria",
"Azerbaijan",
"Bahamas",
"Bahrain",
"Bangladesh",
"Barbados",
"Belarus",
"Belgium",
"Belize",
"Benin",
"Bhutan",
"Bolivia",
"Bosnia and Herzegovina",
"Botswana",
"Brazil",
"Brunei",
"Bulgaria",
"Burkina Faso",
"Burundi",
"Cabo Verde",
"Cambodia",
"Cameroon",
"Canada",
"Central African Republic",
"Chad",
"Chile",
"China",
"Colombia",
"Comoros",
"Congo (Democratic Republic of the)",
"Congo (Republic of the)",
"Costa Rica",
"Côte d'Ivoire",
"Croatia",
"Cuba",
"Cyprus",
"Czechia",
"Denmark",
"Djibouti",
"Dominica",
"Dominican Republic",
"Ecuador",
"Egypt",
"El Salvador",
"Equatorial Guinea",
"Eritrea",
"Estonia",
"Eswatini",
"Ethiopia",
"Fiji",
"Finland",
"France",
"Gabon",
"Gambia",
"Georgia",
"Germany",
"Ghana",
"Greece",
"Grenada",
"Guatemala",
"Guinea",
"Guinea-Bissau",
"Guyana",
"Haiti",
"Honduras",
"Hungary",
"Iceland",
"India",
"Indonesia",
"Iran",
"Iraq",
"Ireland",
"Israel",
"Italy",
"Jamaica",
"Japan",
"Jordan",
"Kazakhstan",
"Kenya",
"Kiribati",
"Kosovo",
"Kuwait",
"Kyrgyzstan",
"Laos",
"Latvia",
"Lebanon",
"Lesotho",
"Liberia",
"Libya",
"Liechtenstein",
"Lithuania",
"Luxembourg",
"Madagascar",
"Malawi",
"Malaysia",
"Maldives",
"Mali",
"Malta",
"Marshall Islands",
"Mauritania",
"Mauritius",
"Mexico",
"Micronesia",
"Moldova",
"Monaco",
"Mongolia",
"Montenegro",
"Morocco",
"Mozambique",
"Myanmar",
"Namibia",
"Nauru",
"Nepal",
"Netherlands",
"New Zealand",
"Nicaragua",
"Niger",
"Nigeria",
"North Korea",
"North Macedonia",
"Norway",
"Oman",
"Pakistan",
"Palau",
"Palestine",
"Panama",
"Papua New Guinea",
"Paraguay",
"Peru",
"Philippines",
"Poland",
"Portugal",
"Qatar",
"Romania",
"Russia",
"Rwanda",
"Saint Kitts and Nevis",
"Saint Lucia",
"Saint Vincent and the Grenadines",
"Samoa",
"San Marino",
"São Tomé and Príncipe",
"Saudi Arabia",
"Senegal",
"Serbia",
"Seychelles",
"Sierra Leone",
"Singapore",
"Slovakia",
"Slovenia",
"Solomon Islands",
"Somalia",
"South Korea",
"South Sudan",
"Spain",
"Sri Lanka",
"Sudan",
"Suriname",
"Sweden",
"Switzerland",
"Syria",
"Taiwan",
"Tajikistan",
"Tanzania",
"Thailand",
"Timor-Leste",
"Togo",
"Tonga",
"Trinidad and Tobago",
"Tunisia",
"Türkiye",
"Turkmenistan",
"Tuvalu",
"Uganda",
"Ukraine",
"United Arab Emirates",
"United Kingdom",
"United States",
"Uruguay",
"Uzbekistan",
"Vanuatu",
"Vatican City",
"Venezuela",
"Vietnam",
"Yemen",
"Zambia",
"Zimbabwe"
];

export const STATE_REQUIRED_COUNTRIES = [
  "United States",
  "Canada",
  "Australia",
];

export const POSTAL_OPTIONAL_COUNTRIES = ["Ireland", "Hong Kong"];
